
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.75606 4.20371L5.584 0.226115C5.41721 0.0753716 5.22251 0 5.00001 0C4.77322 0 4.5807 0.0753502 4.42232 0.226115L0.243874 4.20371C0.081269 4.35843 0 4.5438 0 4.75969C0 4.97968 0.0813589 5.16293 0.243874 5.30952L0.725216 5.76776C0.879301 5.92249 1.07187 6 1.30291 6C1.53397 6 1.7265 5.92251 1.88061 5.76776L5.00001 2.80443L8.11944 5.7677C8.27339 5.92238 8.46594 5.99994 8.6972 5.99994C8.92386 5.99994 9.11865 5.92238 9.28115 5.7677L9.76244 5.30948C9.92078 5.15876 10 4.97546 10 4.75964C10 4.54372 9.91875 4.35837 9.75606 4.20371Z","transform":"translate(13 11) rotate(-180)"}})])
          )
        }
      }
    